import script from "./PopupWhatsApp.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupWhatsApp.vue?vue&type=script&setup=true&lang=js"

import "./PopupWhatsApp.vue?vue&type=style&index=0&id=9e0ac5a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e0ac5a8"]])

export default __exports__